import React, { useEffect } from 'react';
import useFreebieForm from '../../../../hooks/useFreebieForm';
import { useAuth } from '../../../../contexts/AuthContext';
import './FreebieForm.scss';

const FreebieForm = ({ setNotification, setShowFreebieModal, BoutonFormulaire, slug }) => {
    const { user } = useAuth();
    const {
        values,
        errors,
        isSubmitting,
        submitSuccess,
        submitMessage,
        handleChange,
        handleSubmit
    } = useFreebieForm({ setNotification, slug, user });

    // Chargement du script reCAPTCHA v3
    useEffect(() => {
        if (!window.grecaptcha) {
            const loadRecaptcha = () => {
                const script = document.createElement('script');
                script.src = `https://www.google.com/recaptcha/api.js?render=${process.env.REACT_APP_RECAPTCHA_SITE_KEY}`;
                script.async = true;
                document.head.appendChild(script);
            };
            loadRecaptcha();
        }
    }, []);


    useEffect(() => {
        if (submitSuccess) {
            setShowFreebieModal(true);
        }
    }, [submitSuccess])

    return (
        <form className="freebie-form" onSubmit={handleSubmit}>
            <div className="freebie-form__field">
                <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    value={values.email}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className={`freebie-form__input ${errors.email ? 'freebie-form__input--error' : ''}`}
                />
                {errors.email && (
                    <span className="freebie-form__error">{errors.email}</span>
                )}
            </div>

            <div className="freebie-form__field">
                <input
                    type="text"
                    name="prenom"
                    placeholder="Prénom"
                    value={values.prenom}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className={`freebie-form__input ${errors.prenom ? 'freebie-form__input--error' : ''}`}
                />
                {errors.prenom && (
                    <span className="freebie-form__error">{errors.prenom}</span>
                )}
            </div>

            <div className="freebie-form__field">
                <input
                    type="text"
                    name="codePostal"
                    placeholder="Code postal"
                    value={values.codePostal}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className={`freebie-form__input ${errors.codePostal ? 'freebie-form__input--error' : ''}`}
                />
                {errors.codePostal && (
                    <span className="freebie-form__error">{errors.codePostal}</span>
                )}
            </div>

            <div className="freebie-form__field">
                <input
                    type="tel"
                    name="telephone"
                    placeholder="Téléphone (optionnel)"
                    value={values.telephone}
                    onChange={handleChange}
                    disabled={isSubmitting}
                    className={`freebie-form__input ${errors.telephone ? 'freebie-form__input--error' : ''}`}
                />
                {errors.telephone && (
                    <span className="freebie-form__error">{errors.telephone}</span>
                )}
            </div>

            <button
                type="submit"
                disabled={isSubmitting}
                className="freebie-form__submit"
            >
                {isSubmitting ? 'INSCRIPTION EN COURS...' : BoutonFormulaire}
            </button>
        </form>
    );
};

export default FreebieForm;